/** @format */

// import * as React from 'react';
import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "assets/icons";

export const ModalPrompt = ({ onModalClose, modalToggleState, modalTitle, modalContent }) => {
    return (
        <Modal
            open={modalToggleState}
            onClose={onModalClose}
            aria-modal={true}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
        >
            <Box className='subscription-modal'>
                <div className='close-btn-wrapper'>
                    <button onClick={onModalClose} className='modal-close'>
                        <FontAwesomeIcon icon={icons.solid.faXmark} />
                    </button>
                </div>

                <div id='modal-modal-title'>{modalTitle}</div>
                <div id='modal-modal-description'>{modalContent}</div>
            </Box>
        </Modal>
    );
};
